import { render, staticRenderFns } from "./AlterarImagemPaginaRevista.vue?vue&type=template&id=7b1adb6c&scoped=true"
import script from "./AlterarImagemPaginaRevista.vue?vue&type=script&lang=ts"
export * from "./AlterarImagemPaginaRevista.vue?vue&type=script&lang=ts"
import style0 from "./AlterarImagemPaginaRevista.vue?vue&type=style&index=0&id=7b1adb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1adb6c",
  null
  
)

export default component.exports